import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import configuration from '@/config'
import modules from './modules'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'LINE_DIY',
  storage: window.localStorage,
  modules: ['QRCodePopup']
})

const store = new Vuex.Store({
  modules,
  plugins: [vuexLocalStorage.plugin],
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: configuration.NODE_ENV !== 'production'
})

export default store
